import { isEmergencyDepartment } from "../../constants/facilityTypes";

/** CMS OP-18b median discharge time threshold (minutes) for "long wait" ED filter. */
export const WAIT_TIME_FILTER_MAX_MINUTES = 120;

/**
 * Whether a facility should remain visible when the "hide long-wait EDs" filter is on.
 * Non-ED facilities always pass. EDs with missing score_op18b pass. EDs with score > 120 fail.
 *
 * @param {object | null | undefined} facility
 * @param {boolean} filterLongWait
 * @returns {boolean}
 */
export function passesWaitTimeFilter(facility, filterLongWait) {
  if (!filterLongWait) return true;
  if (!isEmergencyDepartment(facility)) return true;
  const score = facility?.score_op18b;
  if (score == null) return true;
  return Number(score) <= WAIT_TIME_FILTER_MAX_MINUTES;
}
